import { LogService } from '../../services/log-service';

function addCommasToNumberString(numberString) {
  // todo handle chinese formatting based on powers of 10,000 (see https://www.wikiwand.com/en/Decimal_mark for more information)
  return numberString.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export class NumberFormattingService {
  static roundToPlace(number, placesToRound, removeTrailingZeroes = false) {
    if (placesToRound === undefined) {
      LogService.logInfo('NumberFormattingService: Cannot round to undefined place', { number, placesToRound, removeTrailingZeroes });
      return undefined;
    }
    if (placesToRound < 1) {
      LogService.logInfo('NumberFormattingService: Cannot round to a place less than 1', { number, placesToRound, removeTrailingZeroes });
      return undefined;
    }
    const placesToRoundFloor = Math.floor(placesToRound);
    const multipleOfTen = 10 ** placesToRoundFloor;
    let fixedNumber = Number.parseFloat((Math.round(number * multipleOfTen) / multipleOfTen).toFixed(placesToRoundFloor));
    if (removeTrailingZeroes) {
      fixedNumber = fixedNumber.toString();
    }
    return fixedNumber;
  }

  static addCommasToNumber(number) {
    if (typeof number !== 'number') {
      return '';
    }
    const numberString = `${number}`;
    const stringParts = numberString.split('.');
    return addCommasToNumberString(stringParts[0]) + (stringParts.length > 1 ? `.${stringParts[1]}` : '');
  }

  static parseStringToNumber(str) {
    return parseFloat(str.replace(/[^(\d-).]/g, ''));
  }

  static coerceOtherTypesToNumber(possibleNumber) {
    switch (typeof possibleNumber) {
      case 'string':
        return this.parseStringToNumber(possibleNumber);
      case 'number':
        return possibleNumber;
      default:
        return Number.NaN;
    }
  }

  static isNumberInteger(value) {
    if (typeof Number.isInteger !== 'undefined') {
      return Number.isInteger(value);
    }
    return typeof value === 'number' && Number.isFinite(value) && Math.floor(value) === value;
  }
}

export const toFixedNumber = (value, fractionalDigits) => {
  if (value === null || value === undefined) {
    return value;
  }
  return Number.parseFloat(Number.parseFloat(value).toFixed(fractionalDigits));
};
